export default Object.freeze({
  EMPTY: 'EMPTY',
  CONSISTENT: 'CONSISTENT',
  SYNCHRONIZING: 'SYNCHRONIZING',
  MODIFIED: 'MODIFIED',
});
